import { parse } from "date-fns";

import { DateObj } from "./DOBField.types";

export const parseDate = (dateObj: DateObj) =>
  parse(`${dateObj.year}-${dateObj.month}-${dateObj.day}`, "yyyy-MM-dd", new Date());
